import {Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {CdExecutionProof} from '../../interfaces/care/cd-execution-proof/cd-execution-proof';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdExecutionProofFactory} from '../../factories/care/cd-execution-proof/cd-execution-proof-factory';

@Injectable({
  providedIn: 'root'
})
export class CdExecutionProofsTable extends SyncTable<CdExecutionProof> {
  constructor() {
    super(db.cdExecutionProofs);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<CdExecutionProof>({
        api: ['care', 'execution-proofs'],
        fromObject: CdExecutionProofFactory.fromObject,
        toRemote: CdExecutionProofFactory.toRemote
      })
    };
  }

  /**
   *
   * @param customerId
   */
  public async getByCustomerId(customerId: number): Promise<CdExecutionProof[]> {
    const cdExecutionProofs = await this.table.where('customerId').equals(customerId).toArray();
    return this.sortByExecutionTimeDesc(cdExecutionProofs);
  }

  /**
   *
   * @param cdCarePlanId
   */
  public async getByCdCarePlanId(cdCarePlanId: number): Promise<CdExecutionProof[]> {
    const cdExecutionProofs = await this.table.where('cdCarePlanId').equals(cdCarePlanId).toArray();
    return this.sortByExecutionTimeDesc(cdExecutionProofs);
  }

  /**
   * Removes all locally stored CdExecutionProofs that originate from the
   * backend (i.e. have a server-assigned id). Entries created locally and
   * not yet pushed (id === null) are left untouched so unsynced work
   * cannot be lost on reload.
   */
  public async clearAllSynced(): Promise<void> {
    const syncedCdExecutionProofs =
      await this.table.filter(cdExecutionProof => cdExecutionProof.id != null).toArray();
    const cdExecutionProofUuids =
      syncedCdExecutionProofs.map(cdExecutionProof => cdExecutionProof.uuid);
    await this.removeMany(cdExecutionProofUuids, true);
  }

  /**
   *
   * @param cdExecutionProofs
   * @private
   */
  private sortByExecutionTimeDesc(cdExecutionProofs: CdExecutionProof[]): CdExecutionProof[] {
    return cdExecutionProofs.sort((a, b) => {
      const aTime = new Date(a.start ?? a.created ?? 0).getTime();
      const bTime = new Date(b.start ?? b.created ?? 0).getTime();
      return bTime - aTime;
    });
  }

}
